var component = require("../../../lib/js/component.js");

function QMIOverview() {
    this.initialize = function (element, options) {
        this.$element = $(element);

        var $carousel = this.$element.find(".Carousel-v2");

        if ($carousel.length) {
            $carousel.attr("aria-label", "QMI Overview carousel");
        }
    };
}

module.exports = component(QMIOverview);
